import {
  PHOTO_COMMENT_LIST,
  PHOTO_COMMENT_EXAMPLE,
  PHOTO_COMMENT_AUTHOR,
  PHOTO_COMMENT_TEXT,
} from "../constants"

class CommentListElement {
  constructor(element) {
    this.element = element
    // Store the example template for cloning
    this.exampleElement = element.querySelector(PHOTO_COMMENT_EXAMPLE)
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_COMMENT_LIST)
    return element ? new CommentListElement(element) : null
  }

  apply(photo) {
    if (!this.element || !this.exampleElement) return

    // Remove existing comments (except example/template)
    const existingComments = Array.from(
      this.element.querySelectorAll(`li:not(${PHOTO_COMMENT_EXAMPLE})`),
    )

    existingComments.forEach((comment) => comment.remove())

    // Add new comments by cloning the example template
    photo.comments.forEach((comment) => {
      // Clone the example element (deep clone to include all children)
      const li = this.exampleElement.cloneNode(true)

      // Remove the example class and add the comment class
      li.classList.remove(PHOTO_COMMENT_EXAMPLE.slice(1))
      li.classList.add("js-photo-gallery-comment")

      // Set the comment ID
      li.dataset.commentId = comment.id

      // Update the author element
      const authorElement = li.querySelector(PHOTO_COMMENT_AUTHOR)
      if (authorElement) {
        authorElement.textContent = comment.authorName || ""
      }

      // Update the text element
      const textElement = li.querySelector(PHOTO_COMMENT_TEXT)
      if (textElement) {
        textElement.textContent = comment.text || ""
      }

      this.element.appendChild(li)
    })
  }
}

export default CommentListElement
